import { leadFormApi } from "@/core/data/api";

export default async (condition) => {
  return await leadFormApi.getLeadFormListPagination(condition);
};
